module.exports = __webpack_public_path__ + "static/media/map2-1.b0437e5e.png";